import React, { useEffect, useState } from 'react'
import WorkItems from './WorkItems';



const Works = () => {

    const [repos, setRepos] = useState([]);

    const getRepos = async () => {
        const response = await fetch("https://api.github.com/users/suhaib-md/starred");
        const FinalData = await response.json();
        setRepos(FinalData)
    }

    useEffect(() => {
        getRepos();
    }, [])

    return (
        <div className="work__container container grid">
        {repos.map((curElem) => {
            return <WorkItems curElem={curElem} key={curElem.id} />
        })}
    </div>
    );
}

export default Works;